import { Component, EventEmitter, Output } from '@angular/core';
import { AnnouncementReadStatusService } from '../services/announcement-read-status.service';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { FileApiService } from '../../../../shared/services/file-api/file-api.service';
import saveAs from 'file-saver';

@Component({
  selector: 'announcement-modal',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss'],
})
export class AnnouncementModalComponent {
  visible: boolean = false;

  dialogQueue: any[] = [];
  currentIndex = 0;

  @Output() saveEmitter = new EventEmitter<any>();

  clickedItem: any = null;
  token: string = '';

  constructor(
    private readonly announcementReadStatusService: AnnouncementReadStatusService,
    private readonly authService: AuthService,
    private readonly fileApiService: FileApiService
  ) {
    this.token = this.authService.getToken() ?? '';
  }

  onPressSave() {
    // Close dialog and reset fields
    //TO DO: kullanıcı okudum anladım butonuna bastığında announcement-read-status tablosuna status u true yapacağız.
    const data = {
      announcement: this.clickedItem?.id,
      user: this?.clickedItem?.announcementToPublish[0]?.user?.id,
    };
    this.announcementReadStatusService.create(data).subscribe((res) => {
      this.saveEmitter.emit(this.clickedItem);
    });

    this.visible = false;
  }

  openDialog(item: any) {
    this.clickedItem = item;
    this.visible = true;
  }

  cancelDialog() {
    this.visible = false;

    setTimeout(() => {
      this.currentIndex++;
      this.openNextDialog();
    }, 300);
  }

  downloadFile(file: any) {
    this.fileApiService
      .getFileBlob(file.fileUrl, this.token)
      .subscribe((blob) => {
        saveAs(blob, file.fileName);
      });
  }

  isAnnouncementRead(item: any): boolean {
    const userId = this.authService.getUserId(); // sistem kullanıcısı id si gelecek
      const readStatus = item?.announcementReadStatuses?.find(
        (status: any) => status.user?.id === userId
      );
      const isSignedUserRead = !!readStatus;
      if (isSignedUserRead) {
        return false;
      } else {
         return true;
      }
  }

  getFileIcon(fileExt: string): string {
    switch (fileExt.toLowerCase()) {
      case 'docx':
      case 'doc':
        return 'fa fa-file-word text-primary'; // Word icon with blue color
      case 'application/pdf':
        return 'fa fa-file-pdf text-danger'; // PDF icon with red color
      case 'image/png':
      case 'image/jpeg':
      case 'image/jpg':
        return 'fa fa-file-image text-warning'; // Image icon with yellow color
      case 'xls':
      case 'xlsx':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return 'fa fa-file-excel text-success'; // Excel icon with green color
      default:
        return 'fa fa-file text-secondary'; // Default file icon
    }
  }

  getDialogHeader(): string {
    return `#${this.clickedItem?.id} ${this.clickedItem?.topic}`;
  }


  startAnnouncementFlow(list: any[]) {
    if (!list?.length) return;

    this.dialogQueue = [...list];
    this.currentIndex = 0;

    this.openNextDialog();
  }

  openNextDialog() {
/*    if (this.currentIndex >= this.dialogQueue.length) {
      this.visible = false;
      return;
    }*/

    if (this.dialogQueue[this.currentIndex]) {
      this.clickedItem = this.dialogQueue[this.currentIndex];
      this.visible = true;
    }
  }
}
